import { Dialog, Grid, StepLabel, styled, Theme, Typography } from '@material-ui/core';

export const StyledDialog = styled(Dialog)<Theme>(() => ({
  margin: 24,
  '& .MuiDialog-paper': {
    borderRadius: 8,
  },
}));

export const StepperTitle = styled(Typography)<Theme>(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '28px',
  fontWeight: 400,
  lineHeight: '46px',
  color: theme.palette.primary.main,
}));

export const StepperLabel = styled(StepLabel)<Theme>(({ theme }) => ({
  '& .MuiStepLabel-labelContainer .MuiStepLabel-label': {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '22px',
  },
}));

export const StepperIconTitle = styled(Typography)<Theme>(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '30px',
  color: theme.palette.ternary.main,
}));

export const StepperGrid = styled(Grid)<Theme>(({ theme }) => ({
  '& div img': {
    width: '100%',
    height: 'auto',
  },
  '& div iframe': {
    width: '100%',
  },
}));
